// extracted by mini-css-extract-plugin
module.exports = {"dataTableFormat":"styles_dataTableFormat__IZmPH","formSpace":"styles_formSpace__3L3Xc"};